// src/components/StreamAttachmentComponent.js - VERSÃO CORRIGIDA COM VISUALIZAÇÃO
import React, { useState } from 'react';
import { View, TouchableOpacity, Alert, Image, Linking, Platform, Modal } from 'react-native';
import { 
  Card, 
  Text, 
  IconButton, 
  Chip,
  Badge,
  ActivityIndicator,
  Button
} from 'react-native-paper';
import { AVAQualisTheme } from '../theme/theme';

// Importar estilos do AttachmentComponent original
let styles;
try {
  styles = require('./AttachmentComponent.css').styles;
} catch (error) {
  console.warn('⚠️ Arquivo de estilos não encontrado, usando estilos padrão');
  styles = {
    attachmentsList: { marginTop: 16 },
    attachmentsTitle: { fontSize: 14, fontWeight: '600', marginBottom: 8, color: '#333' },
    attachmentCard: { marginBottom: 8, backgroundColor: '#f5f5f5', borderRadius: 8 },
    attachmentContent: { padding: 12 },
    attachmentHeader: { flexDirection: 'row', alignItems: 'flex-start' },
    attachmentInfo: { flexDirection: 'row', flex: 1, alignItems: 'flex-start' },
    attachmentIcon: { width: 60, height: 60, marginRight: 12, borderRadius: 8, justifyContent: 'center', alignItems: 'center', backgroundColor: '#e0e0e0' },
    thumbnailImage: { width: '100%', height: '100%', borderRadius: 8 },
    videoThumbnail: { width: '100%', height: '100%', backgroundColor: '#e0e0e0', justifyContent: 'center', alignItems: 'center', borderRadius: 8 },
    videoIcon: { fontSize: 24 },
    linkIcon: { width: '100%', height: '100%', backgroundColor: '#e3f2fd', justifyContent: 'center', alignItems: 'center', borderRadius: 8 },
    linkIconText: { fontSize: 20 },
    fileIcon: { fontSize: 28 },
    attachmentDetails: { flex: 1 },
    attachmentName: { fontSize: 14, fontWeight: '600', marginBottom: 2, color: '#333' },
    attachmentSize: { fontSize: 11, color: '#666', marginBottom: 4 },
    attachmentDescription: { fontSize: 12, color: '#666', fontStyle: 'italic', marginBottom: 4 },
    attachmentValidity: { fontSize: 11, color: '#666', fontWeight: '600' },
    attachmentValidityExpired: { color: '#f44336' },
    attachmentValidityWarning: { color: '#ff9800' },
    viewButtonMain: { margin: 0, backgroundColor: 'rgba(164, 198, 57, 0.1)' },
    streamBadge: { position: 'absolute', top: -4, right: -4, backgroundColor: '#4CAF50' },
    localBadge: { backgroundColor: '#FF9800', marginTop: 4 },
    syncedBadge: { backgroundColor: '#2196F3', marginTop: 4 },
    loadingContainer: { padding: 20, alignItems: 'center' },
    noAttachmentsText: { fontSize: 14, color: '#999', fontStyle: 'italic', textAlign: 'center', padding: 20 }
  };
}

const StreamAttachmentComponent = ({ attachments = [] }) => {
  const [imagePreviewModal, setImagePreviewModal] = useState({
    visible: false,
    imageUrl: '',
    imageName: ''
  });
  const [loadingImage, setLoadingImage] = useState({});

  // Função para obter emoji do tipo de arquivo
  const getFileEmoji = (mimeType, fileName) => {
    if (!mimeType && !fileName) return '📎';
    
    const type = mimeType?.toLowerCase() || fileName?.toLowerCase() || '';
    
    if (type.includes('pdf')) return '📄';
    if (type.includes('doc') || type.includes('word')) return '📝';
    if (type.includes('sheet') || type.includes('excel') || type.includes('csv')) return '📊';
    if (type.includes('zip') || type.includes('rar') || type.includes('7z')) return '🗜️';
    if (type.includes('image') || type.includes('jpg') || type.includes('png') || type.includes('gif')) return '🖼️';
    if (type.includes('video') || type.includes('mp4') || type.includes('avi')) return '🎥';
    if (type.includes('audio') || type.includes('mp3') || type.includes('wav')) return '🎵';
    if (type.includes('text') || type.includes('txt')) return '📃';
    if (type.includes('presentation') || type.includes('ppt')) return '📽️';
    
    return '📎';
  };

  // Função para formatar tamanho de arquivo
  const formatFileSize = (bytes) => {
    if (!bytes) return '';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  // Função de formatação de data
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    try {
      if (typeof dateString === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
        return dateString;
      }
      
      const date = new Date(dateString);
      
      if (isNaN(date.getTime())) {
        return '';
      }
      
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      
      return `${day}/${month}/${year}`;
    } catch (error) {
      return '';
    }
  };

  // Função para verificar se a data está vencida
  const isExpired = (dateString) => {
    if (!dateString) return false;
    
    try {
      let date;
      
      if (typeof dateString === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
        const [day, month, year] = dateString.split('/').map(Number);
        date = new Date(year, month - 1, day);
      } else {
        date = new Date(dateString);
      }
      
      if (isNaN(date.getTime())) {
        return false;
      }
      
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    } catch (error) {
      return false;
    }
  };

  // Função para verificar se a data está próxima do vencimento (30 dias)
  const isNearExpiry = (dateString) => {
    if (!dateString) return false;
    
    try {
      let date;
      
      if (typeof dateString === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
        const [day, month, year] = dateString.split('/').map(Number);
        date = new Date(year, month - 1, day);
      } else {
        date = new Date(dateString);
      }
      
      if (isNaN(date.getTime())) {
        return false;
      }
      
      const today = new Date();
      const diffTime = date - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays <= 30 && diffDays >= 0;
    } catch (error) {
      return false;
    }
  };

  // FUNÇÃO CORRIGIDA: Visualizar anexo com melhor suporte
  const handleViewAttachment = (attachment) => {
    console.log('🔍 Visualizando anexo no stream:', attachment);

    // Para imagens
    if (attachment.type === 'photo' || attachment.isImage) {
      const imageUrl = attachment.url;
      
      if (!imageUrl) {
        Alert.alert(
          '⚠️ Imagem não disponível',
          'Esta imagem ainda não foi processada ou está disponível apenas localmente no dispositivo do avaliador.',
          [{ text: 'OK' }]
        );
        return;
      }

      // Se for base64, abrir no modal
      if (imageUrl.startsWith('data:')) {
        setImagePreviewModal({
          visible: true,
          imageUrl: imageUrl,
          imageName: attachment.name || 'Imagem'
        });
      } 
      // Se for URL web normal
      else if (Platform.OS === 'web') {
        // Tentar abrir em nova aba
        window.open(imageUrl, '_blank');
      } 
      // No mobile, abrir no modal
      else {
        setImagePreviewModal({
          visible: true,
          imageUrl: imageUrl,
          imageName: attachment.name || 'Imagem'
        });
      }
    } 
    // Para links
    else if (attachment.type === 'link' || attachment.isLink) {
      let finalUrl = attachment.url;
      if (!finalUrl.startsWith('http://') && !finalUrl.startsWith('https://')) {
        finalUrl = 'https://' + finalUrl;
      }
      
      if (Platform.OS === 'web') {
        window.open(finalUrl, '_blank');
      } else {
        Linking.openURL(finalUrl).catch(err => {
          console.error('Erro ao abrir link:', err);
          Alert.alert('❌ Erro', 'Não foi possível abrir o link');
        });
      }
    }
    // Para vídeos
    else if (attachment.type === 'video' || attachment.isVideo) {
      const videoUrl = attachment.url;
      
      if (!videoUrl) {
        Alert.alert(
          '⚠️ Vídeo não disponível',
          'Este vídeo ainda não foi processado ou está disponível apenas localmente.',
          [{ text: 'OK' }]
        );
        return;
      }

      if (Platform.OS === 'web') {
        // Abrir em nova aba
        window.open(videoUrl, '_blank');
      } else {
        // Tentar abrir com app padrão
        Linking.openURL(videoUrl).catch(err => {
          Alert.alert(
            '🎥 Vídeo',
            `Nome: ${attachment.name}\nTamanho: ${formatFileSize(attachment.size)}\n\nNão foi possível abrir o vídeo diretamente.`,
            [{ text: 'OK' }]
          );
        });
      }
    }
    // Para outros arquivos (PDF, DOC, etc)
    else {
      const fileUrl = attachment.url;
      
      if (!fileUrl) {
        Alert.alert(
          `📎 ${attachment.name || 'Arquivo'}`,
          `Tipo: ${attachment.mimeType || 'Não especificado'}\n` +
          `Tamanho: ${attachment.size ? formatFileSize(attachment.size) : 'Desconhecido'}\n` +
          `Descrição: ${attachment.description || 'Sem descrição'}\n\n` +
          `⚠️ Este arquivo está armazenado localmente no dispositivo do avaliador e não pode ser acessado remotamente.`,
          [{ text: 'OK' }]
        );
        return;
      }

      // Se for base64 de PDF, criar blob e abrir
      if (fileUrl.startsWith('data:') && Platform.OS === 'web') {
        try {
          // Converter base64 para blob
          const base64Data = fileUrl.split(',')[1];
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: attachment.mimeType || 'application/octet-stream' });
          const blobUrl = URL.createObjectURL(blob);
          
          // Abrir em nova aba
          window.open(blobUrl, '_blank');
          
          // Limpar URL após alguns segundos
          setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
        } catch (error) {
          console.error('Erro ao processar arquivo base64:', error);
          Alert.alert('❌ Erro', 'Não foi possível abrir o arquivo');
        }
      }
      // Se for URL normal
      else if (Platform.OS === 'web') {
        window.open(fileUrl, '_blank');
      }
      // No mobile
      else {
        Linking.openURL(fileUrl).catch(err => {
          Alert.alert(
            `📎 ${attachment.name || 'Arquivo'}`,
            `Tipo: ${attachment.mimeType || 'Não especificado'}\n` +
            `Tamanho: ${attachment.size ? formatFileSize(attachment.size) : 'Desconhecido'}\n` +
            `Descrição: ${attachment.description || 'Sem descrição'}\n\n` +
            `Não foi possível abrir este arquivo diretamente.`,
            [{ text: 'OK' }]
          );
        });
      }
    }
  };

  if (!attachments || attachments.length === 0) {
    return (
      <View style={styles.attachmentsList}>
        <Text style={styles.attachmentsTitle}>
          📎 Anexos
        </Text>
        <Text style={styles.noAttachmentsText}>
          Nenhum anexo adicionado ainda
        </Text>
      </View>
    );
  }

  return (
    <View style={styles.attachmentsList}>
      <Text style={styles.attachmentsTitle}>
        📎 Anexos ({attachments.length})
      </Text>
      
      {attachments.map((attachment, index) => (
        <TouchableOpacity
          key={attachment.id || index}
          style={styles.attachmentCard}
          onPress={() => handleViewAttachment(attachment)}
          activeOpacity={0.7}
        >
          <Card.Content style={styles.attachmentContent}>
            <View style={styles.attachmentHeader}>
              <View style={styles.attachmentInfo}>
                {/* Ícone/Thumbnail */}
                <View style={styles.attachmentIcon}>
                  {(attachment.type === 'photo' || attachment.isImage) && attachment.url ? (
                    <>
                      <Image 
                        source={{ uri: attachment.url }} 
                        style={styles.thumbnailImage}
                        onLoadStart={() => setLoadingImage(prev => ({ ...prev, [attachment.id]: true }))}
                        onLoadEnd={() => setLoadingImage(prev => ({ ...prev, [attachment.id]: false }))}
                        onError={(error) => {
                          setLoadingImage(prev => ({ ...prev, [attachment.id]: false }));
                          console.warn('Não foi possível carregar thumbnail:', attachment.name);
                        }}
                      />
                      {loadingImage[attachment.id] && (
                        <View style={{ position: 'absolute' }}>
                          <ActivityIndicator size="small" color={AVAQualisTheme.colors.primary} />
                        </View>
                      )}
                    </>
                  ) : attachment.type === 'video' || attachment.isVideo ? (
                    <View style={styles.videoThumbnail}>
                      <Text style={styles.videoIcon}>🎥</Text>
                    </View>
                  ) : attachment.type === 'link' || attachment.isLink ? (
                    <View style={styles.linkIcon}>
                      <Text style={styles.linkIconText}>🔗</Text>
                    </View>
                  ) : (
                    <Text style={styles.fileIcon}>
                      {getFileEmoji(attachment.mimeType, attachment.name)}
                    </Text>
                  )}
                  
                  {/* Badge indicando stream */}
                  <Badge style={styles.streamBadge} size={16}>
                    📡
                  </Badge>
                </View>

                {/* Informações do anexo */}
                <View style={styles.attachmentDetails}>
                  <Text style={styles.attachmentName} numberOfLines={1}>
                    {attachment.type === 'link' || attachment.isLink
                      ? attachment.url 
                      : attachment.name || 'Arquivo sem nome'
                    }
                  </Text>
                  
                  {attachment.size && (
                    <Text style={styles.attachmentSize}>
                      📏 {formatFileSize(attachment.size)}
                    </Text>
                  )}
                  
                  <Text style={styles.attachmentDescription} numberOfLines={2}>
                    {attachment.description}
                  </Text>

                  {/* Mostrar data de validade se existir */}
                  {attachment.validityDate && (
                    <Text style={[
                      styles.attachmentValidity,
                      isExpired(attachment.validityDate) && styles.attachmentValidityExpired,
                      isNearExpiry(attachment.validityDate) && styles.attachmentValidityWarning
                    ]}>
                      📅 Válido até: {formatDate(attachment.validityDate)}
                      {isExpired(attachment.validityDate) && ' (VENCIDO)'}
                      {isNearExpiry(attachment.validityDate) && !isExpired(attachment.validityDate) && ' (PRÓXIMO DO VENCIMENTO)'}
                    </Text>
                  )}
                  
                  {/* Badges de status */}
                  <View style={{ flexDirection: 'row', gap: 8, marginTop: 4 }}>
                    {attachment.isLocal && (
                      <Chip compact mode="flat" style={styles.localBadge} textStyle={{ fontSize: 10 }}>
                        📱 Local
                      </Chip>
                    )}
                    {attachment.isSynced && (
                      <Chip compact mode="flat" style={styles.syncedBadge} textStyle={{ fontSize: 10 }}>
                        ☁️ Sincronizado
                      </Chip>
                    )}
                  </View>
                </View>
              </View>

              {/* Ícone de visualização */}
              <IconButton
                icon="magnify"
                size={24}
                iconColor={AVAQualisTheme.colors.primary}
                style={styles.viewButtonMain}
              />
            </View>
          </Card.Content>
        </TouchableOpacity>
      ))}

      {/* Modal de Preview de Imagem */}
      <Modal
        visible={imagePreviewModal.visible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setImagePreviewModal({ visible: false, imageUrl: '', imageName: '' })}
      >
        <TouchableOpacity 
          style={{
            flex: 1,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            justifyContent: 'center',
            alignItems: 'center'
          }}
          activeOpacity={1}
          onPress={() => setImagePreviewModal({ visible: false, imageUrl: '', imageName: '' })}
        >
          <View style={{
            width: '90%',
            maxHeight: '80%',
            backgroundColor: 'white',
            borderRadius: 8,
            overflow: 'hidden'
          }}>
            {/* Header do Modal */}
            <View style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: 16,
              backgroundColor: AVAQualisTheme.colors.primary
            }}>
              <Text style={{
                color: 'white',
                fontSize: 16,
                fontWeight: 'bold',
                flex: 1,
                marginRight: 8
              }} numberOfLines={1}>
                📸 {imagePreviewModal.imageName}
              </Text>
              <TouchableOpacity
                onPress={() => setImagePreviewModal({ visible: false, imageUrl: '', imageName: '' })}
                style={{ padding: 4 }}
              >
                <Text style={{ color: 'white', fontSize: 20 }}>✕</Text>
              </TouchableOpacity>
            </View>
            
            {/* Imagem */}
            <View style={{
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#f0f0f0'
            }}>
              <Image 
                source={{ uri: imagePreviewModal.imageUrl }}
                style={{
                  width: '100%',
                  height: undefined,
                  aspectRatio: 1,
                  resizeMode: 'contain'
                }}
                onError={(error) => {
                  console.error('❌ Erro ao carregar imagem:', error);
                  Alert.alert(
                    '❌ Erro', 
                    'Não foi possível carregar a imagem.',
                    [{ 
                      text: 'OK', 
                      onPress: () => setImagePreviewModal({ visible: false, imageUrl: '', imageName: '' })
                    }]
                  );
                }}
              />
            </View>
            
            {/* Botões de ação */}
            {Platform.OS === 'web' && (
              <View style={{
                flexDirection: 'row',
                padding: 16,
                backgroundColor: 'white',
                borderTopWidth: 1,
                borderTopColor: '#e0e0e0'
              }}>
                <Button
                  mode="contained"
                  onPress={() => {
                    if (imagePreviewModal.imageUrl.startsWith('data:')) {
                      // Se for base64, criar blob e abrir
                      try {
                        const base64Data = imagePreviewModal.imageUrl.split(',')[1];
                        const byteCharacters = atob(base64Data);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                          byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], { type: 'image/jpeg' });
                        const blobUrl = URL.createObjectURL(blob);
                        window.open(blobUrl, '_blank');
                        setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
                      } catch (error) {
                        console.error('Erro ao abrir imagem:', error);
                      }
                    } else {
                      window.open(imagePreviewModal.imageUrl, '_blank');
                    }
                  }}
                  icon="open-in-new"
                  style={{ flex: 1, marginRight: 8 }}
                >
                  Abrir em Nova Aba
                </Button>
                
                <Button
                  mode="outlined"
                  onPress={() => setImagePreviewModal({ visible: false, imageUrl: '', imageName: '' })}
                  style={{ flex: 1 }}
                >
                  Fechar
                </Button>
              </View>
            )}
          </View>
        </TouchableOpacity>
      </Modal>
    </View>
  );
};

export default StreamAttachmentComponent;